import { Dispatch } from 'redux'
import { AllCards, AllCardsType } from '../../data/all-cards'
import {
    CLOSE_SESSION,
    ERROR,
    ERROR_LOGIN,
    GET_ALL_CARDS,
    GET_ALL_CONSULTS,
    GET_CLIENTS,
    GET_CONSULT_APPEND,
    GET_CONSULT_START,
    GET_SESSIONS,
    GET_USERS,
    LOGIN,
    LOGOUT,
    POSITION_CARD,
    RESET_CLIENT,
    RESET_CONSULT,
    RESET_ERROR,
    SAVE_ALL_CARDS,
    SAVE_CLIENT,
    SAVE_CONSULT,
    SELECT_CARD,
    SET_CLIENT,
    SET_CONTROL,
} from '../constants'
import axios from 'axios'
import Swal from 'sweetalert2'
import { deleteSession, getActiveSessions, getDeviceFingerprint } from '../../utils/functions'
import { Moment } from 'moment'
import { NombreTarotista, Personalidades } from '../../data/personality'
import { buildSystemPromptExtras, reinforceAddressee, reinforceConsulta } from '../../data/prompt-base'

const headers = {
    'X-Parse-Application-Id': process.env.REACT_APP_BACK4APP_APPLICATION_ID,
    'X-Parse-REST-API-Key': process.env.REACT_APP_BACK4APP_REST_API_KEY,
    'X-Parse-Revocable-Session': '1',
    'Content-Type': 'application/json',
}

export const GetAllCards = () => (dispatch: Dispatch) => {
    let response = AllCards
    dispatch({
        type: GET_ALL_CARDS,
        payload: response,
    })
}

export const SaveAllCards = (payload: AllCardsType[]) => (dispatch: Dispatch) => {
    dispatch({
        type: SAVE_ALL_CARDS,
        payload: payload,
    })
}

export const UserLogin = (payload: any) => async (dispatch: Dispatch) => {
    try {
        const deviceId = await getDeviceFingerprint()

        const response = await axios.get(
            `https://parseapi.back4app.com/login?username=${payload.username}&password=${payload.password}`,
            {
                headers: {
                    'X-Parse-Application-Id': process.env.REACT_APP_BACK4APP_APPLICATION_ID,
                    'X-Parse-REST-API-Key': process.env.REACT_APP_BACK4APP_REST_API_KEY,
                    'X-Parse-Installation-Id': deviceId,
                    'Content-Type': 'application/json',
                },
            }
        )

        const sesiones = await getActiveSessions(response.data.objectId)

        console.log('Sesiones:', sesiones)

        if (sesiones.length > response.data.sesiones) {
            /* Swal.fire(
                'Sesiones Excedidas',
                'Se ha excedido en la cantidad de Sesiones abiertas. Cierre una sesión para ingresar aquí',
                'error'
            )
            deleteSession(sesiones[sesiones.length - 1].objectId)
            dispatch({
                type: LOGOUT,
                payload: null,
            }) */
            deleteSession(sesiones[0].objectId)
            Swal.fire({
                title: 'Sesiones Excedidas',
                text: 'Ha excedido su límite de sesiones, he cerrado su sesión más antigua.',
                timer: 2000,
                icon: 'warning',
                timerProgressBar: true,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
            })
        }
        dispatch({
            type: LOGIN,
            payload: response.data,
        })
    } catch (error: any) {
        dispatch({
            type: ERROR_LOGIN,
            payload: error,
        })
    }
}

export const CheckUser = (sessionId: string) => async (dispatch: Dispatch) => {
    try {
        const response = await fetch('https://parseapi.back4app.com/users/me', {
            method: 'GET',
            headers: {
                'X-Parse-Application-Id': process.env.REACT_APP_BACK4APP_APPLICATION_ID!,
                'X-Parse-REST-API-Key': process.env.REACT_APP_BACK4APP_REST_API_KEY!,
                'X-Parse-Session-Token': sessionId,
                'Content-Type': 'application/json',
            },
        })

        const data = await response.json()

        if (response.ok) {
            dispatch({
                type: LOGIN,
                payload: data,
            })
        } else {
            localStorage.removeItem('user')
            dispatch({
                type: LOGOUT,
                payload: null,
            })
        }
    } catch (error: any) {
        localStorage.removeItem('user')
        dispatch({
            type: LOGOUT,
            payload: null,
        })
    }
}

export const ResetError = () => (dispatch: Dispatch) => {
    dispatch({
        type: RESET_ERROR,
        payload: null,
    })
}

export const SetUser = (payload: any) => (dispatch: Dispatch) => {
    dispatch({
        type: LOGIN,
        payload: payload,
    })
}

export const GetAllConsults = (pageSize: number, skip: number) => async (dispatch: Dispatch) => {
    try {
        const response = await axios.get(
            `https://parseapi.back4app.com/classes/consults?order=-createdAt&limit=${pageSize}&skip=${skip}`,
            { headers }
        )
        dispatch({
            type: GET_ALL_CONSULTS,
            payload: response.data.results,
        })
    } catch (error: any) {
        dispatch({
            type: ERROR,
            payload: error.message,
        })
    }
}

export const GetConsultsByUser = (username: string, pageSize: number, skip: number) => async (dispatch: Dispatch) => {
    try {
        const response = await axios.get(
            `https://parseapi.back4app.com/classes/consults?order=-createdAt&limit=${pageSize}&skip=${skip}&where={"user":"${username}"}`,
            { headers }
        )

        dispatch({
            type: GET_ALL_CONSULTS,
            payload: response.data.results,
        })
    } catch (error: any) {
        dispatch({
            type: ERROR,
            payload: error.message,
        })
    }
}

export const Logout = (sessionId: string) => async (dispatch: Dispatch) => {
    try {
        const response = await fetch('https://parseapi.back4app.com/logout', {
            method: 'POST',
            headers: {
                'X-Parse-Application-Id': process.env.REACT_APP_BACK4APP_APPLICATION_ID!,
                'X-Parse-REST-API-Key': process.env.REACT_APP_BACK4APP_REST_API_KEY!,
                'X-Parse-Session-Token': sessionId, // Necesario para invalidar la sesión
                'Content-Type': 'application/json',
            },
        })

        if (response.ok) {
            localStorage.removeItem('user') // Eliminar user local
            dispatch({
                type: LOGOUT,
                payload: null,
            })
        } else {
            dispatch({
                type: ERROR,
                payload: await response.json(),
            })
        }
    } catch (error: any) {
        dispatch({
            type: ERROR,
            payload: error.message,
        })
    }
}

export const GetConsult = (value: any) => async (dispatch: Dispatch) => {
    dispatch({
        type: GET_CONSULT_START,
        payload: null,
    })

    // const modelIA = value.type === 'general' ? 'gpt-3.5-turbo' : 'gpt-4o-mini'

    const modelIA = 'grok-4.3'

    /* const messages = [
        {
            role: 'system',
            content:
                'Eres una experta tarotista y astróloga esotérica de Argentina, con un profundo conocimiento sobre energía, atracción, manifestación y Registros Akáshicos, intuitiva. Exprésate en un tono cercano y amigable. No te refieras al consultante en tercera persona.',
        },
        { role: 'user', content: value.consult },
    ] */

    const personality = Personalidades[value.personality as NombreTarotista]
    const trato = personality?.addressForm ?? 'vos'

    const messages = [
        {
            role: 'system' as const,
            content: personality.system + '\n\n' + buildSystemPromptExtras(value.type, value.cards, trato),
        },
        {
            role: 'user' as const,
            content:
                value.consult +
                reinforceAddressee(value.clientName, trato) +
                reinforceConsulta(value.clientAnswer),
        },
    ]

    const controller = new AbortController()

    try {
        // 3) Consumir el stream
        const maxTokens = value.type === 'carta-natal-premium' ? 16384 : 4500

        const res = await fetch('/api/chat-stream-grok', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                messages,
                model: modelIA,
                ...(maxTokens ? { max_tokens: maxTokens } : {}),
            }),
            signal: controller.signal,
        })

        if (!res.ok || !res.body) {
            throw new Error(`Stream error: ${res.status}`)
        }

        const reader = res.body.getReader()
        const decoder = new TextDecoder()
        let fullText = ''

        while (true) {
            const { value: chunk, done } = await reader.read()
            if (done) break
            const text = decoder.decode(chunk, { stream: true })
            fullText += text

            // 🔹 actualiza la UI en vivo (append)
            dispatch({
                type: GET_CONSULT_APPEND,
                payload: text,
            })
        }

        // 4) Guarda en tu backend cuando termine el stream
        const data = {
            clientName: value.clientName,
            clientPhone: value.clientPhone || '',
            clientAnswer: value.clientAnswer,
            type: value.type,
            cards: value.cards,
            response: fullText,
            user: value.user,
            consult: value.consult,
            ...(value.comboId && {
                comboId: value.comboId,
                comboName: value.comboName,
                comboStep: value.comboStep,
                comboTotalSteps: value.comboTotalSteps,
            }),
        }

        await axios.post('https://parseapi.back4app.com/classes/consults', data, { headers })

        dispatch({ type: SAVE_CONSULT, payload: data })

        // opcional: devolver el texto completo al que llame la acción
        return fullText
    } catch (err: any) {
        dispatch({
            type: ERROR,
            payload: err.message || 'Stream failed',
        })
        throw err
    } finally {
        /* dispatch({
            type: RESET_CONSULT,
            payload: null,
        }) */
    }
}

export const SetConsult = (value: any) => async (dispatch: Dispatch) => {
    const data = {
        clientName: value.clientName,
        clientPhone: value.clientPhone || '',
        clientAnswer: value.clientAnswer,
        type: value.type,
        cards: value.cards,
        response: value.consult,
        user: value.user,
        consult: value.consult,
    }

    await axios.post('https://parseapi.back4app.com/classes/consults', data, {
        headers,
    })

    dispatch({
        type: SAVE_CONSULT,
        payload: data,
    })
}

export const ResetConsult = () => (dispatch: Dispatch) => {
    dispatch({
        type: RESET_CONSULT,
        payload: null,
    })
}

export const SaveClient = (value: any) => async (dispatch: Dispatch) => {
    try {
        console.log('value:', value)
        const arreglo = Array(10)
        arreglo.fill({ video: false, audio: false, indications: false, extra: false, razones: false })
        let data: any = {
            name: value.name,
            birthday: value.date,
            phone: value.phone,
            email: value.email,
            obs: value.obs,
            status: 'active',
            control: arreglo,
        }

        const response = await axios.post('https://parseapi.back4app.com/classes/clients', data, { headers })
        data.objectId = response.data.objectId
        Swal.fire('Cliente Guardado', 'El cliente ha sido agregado a la base de datos', 'success')

        dispatch({
            type: SAVE_CLIENT,
            payload: data,
        })
    } catch (error: any) {
        dispatch({
            type: ERROR,
            payload: error.message,
        })
    }
}

export const ResetClient = () => async (dispatch: Dispatch) => {
    dispatch({
        type: RESET_CLIENT,
        payload: null,
    })
}

export const GetClients = () => async (dispatch: Dispatch) => {
    try {
        const response = await axios.get('https://parseapi.back4app.com/classes/clients', { headers })

        dispatch({
            type: GET_CLIENTS,
            payload: response.data.results,
        })
    } catch (error: any) {
        dispatch({
            type: ERROR,
            payload: error.message,
        })
    }
}

export const SetClient = (value: any) => (dispatch: Dispatch) => {
    dispatch({
        type: SET_CLIENT,
        payload: value,
    })
}

export const SetControl =
    (clientId: string, arreglo: any, position: number, item: string, value: boolean) => async (dispatch: Dispatch) => {
        try {
            arreglo[position][item] = value
            await axios.put(
                'https://parseapi.back4app.com/classes/clients/' + clientId,
                { control: arreglo },
                { headers }
            )

            dispatch({
                type: SET_CONTROL,
                payload: arreglo,
            })
        } catch (error: any) {
            dispatch({
                type: ERROR,
                payload: error.message,
            })
        }
    }

export const GetUsers = () => async (dispatch: Dispatch) => {
    try {
        const response = await axios.get(`https://parseapi.back4app.com/classes/_User?order=username`, { headers })

        dispatch({
            type: GET_USERS,
            payload: response.data.results,
        })
    } catch (error: any) {
        dispatch({
            type: ERROR,
            payload: error.message,
        })
    }
}

export const GetSessions = () => async (dispatch: Dispatch) => {
    try {
        const response = await axios.get('https://parseapi.back4app.com/classes/_Session', {
            headers: {
                'X-Parse-Application-Id': process.env.REACT_APP_BACK4APP_APPLICATION_ID!,
                'X-Parse-REST-API-Key': process.env.REACT_APP_BACK4APP_REST_API_KEY!,
                'X-Parse-Master-Key': process.env.REACT_APP_BACK4APP_MASTER_KEY!,
                'Content-Type': 'application/json',
            },
        })

        dispatch({
            type: GET_SESSIONS,
            payload: response.data.results,
        })
    } catch (error: any) {
        dispatch({
            type: ERROR,
            payload: error.message,
        })
    }
}

export const CloseSession = (sessionId: string) => async (dispatch: Dispatch) => {
    try {
        await fetch(`https://parseapi.back4app.com/classes/_Session/${sessionId}`, {
            method: 'DELETE',
            headers: {
                'X-Parse-Application-Id': process.env.REACT_APP_BACK4APP_APPLICATION_ID!,
                'X-Parse-REST-API-Key': process.env.REACT_APP_BACK4APP_REST_API_KEY!,
                'X-Parse-Master-Key': process.env.REACT_APP_BACK4APP_MASTER_KEY!,
                'Content-Type': 'application/json',
            },
        })

        dispatch({
            type: CLOSE_SESSION,
            payload: sessionId,
        })
    } catch (error: any) {
        dispatch({
            type: ERROR,
            payload: error.message,
        })
    }
}

export const GetConsultsByDate = (date: Moment) => async (dispatch: Dispatch) => {
    console.log('date de la action:', date)
    try {
        const where = {
            createdAt: {
                $gte: date.startOf('day'),
                $lte: date.endOf('day'),
            },
        }

        console.log('Where:', where)

        const response = await axios.get('https://parseapi.back4app.com/classes/consults', {
            headers,
            params: {
                where: JSON.stringify(where),
                count: 1,
                limit: 1000,
            },
        })

        dispatch({
            type: GET_ALL_CONSULTS,
            payload: response.data.results,
        })
    } catch (error: any) {
        dispatch({
            type: ERROR,
            payload: error.message,
        })
    }
}

export const SelectOneCard = (index: number) => (dispatch: Dispatch) => {
    dispatch({
        type: SELECT_CARD,
        payload: index,
    })
}

export const PositionCard = (index: number) => (dispatch: Dispatch) => {
    console.log('entre a la action')
    dispatch({
        type: POSITION_CARD,
        payload: index,
    })
}
